<script setup lang="ts">
const route = useRoute()
const keywords = ref(route.query.query?.toString() || '')
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

watchEffect(() => {
  keywords.value = route.query.query?.toString() || ''
})

const search = () => {
  navigateTo({ path: `/search/`, query: { query: keywords.value } })
}
</script>

<template>
  <Section :class="['section-hero-search', 'grid']">
    <div v-animate="{ animation: 'vertical-reveal' }" class="form">
      <Icon name="search" />
      <input
        v-model="keywords"
        type="text"
        class="text-xlarge"
        :placeholder="t('search.form.keywords.placeholder')"
        :aria-label="t('search.form.keywords.placeholder')"
        @keyup.enter="search"
      />
      <Button secondary icon="arrow-left" slide :aria-label="t('search.form.button')" @click="search">
        {{ t('search.form.button') }}
      </Button>
    </div>
  </Section>
</template>

<style lang="scss" scoped>
.section-hero-search {
  --hero-height: 210px;

  display: grid;
  margin-bottom: 0;
  padding: 24px;

  background: var(--c-red-dark-100);

  min-height: var(--hero-height);

  align-items: center;

  @include breakpoint(tl) {
    --hero-height: 420px;
    padding: 80px;
  }
}

.form {
  width: 100%;

  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 20px 10px;

  @include breakpoint(tl) {
    grid-template-columns: auto 1fr auto;
    gap: 20px;
  }

  :deep(> svg) {
    color: var(--c-white);

    width: 20px;
    height: 21px;

    @include breakpoint(t) {
      width: 25px;
      height: 25px;
    }
  }

  input {
    width: 100%;

    border: none;
    outline: none;
    appearance: none;
    margin: 0;
    width: 100%;
    background: transparent;
    color: var(--c-white);

    @include placeholder {
      opacity: 0.25;
      color: var(--c-white);
    }
    @include breakpoint(t down) {
      font-size: 24px;
      font-weight: normal;
    }
  }

  .button {
    margin-left: auto;
    grid-column: 2;

    margin-top: 10px;

    @include breakpoint(tl) {
      grid-column: auto;
      margin-left: none;

      margin-top: 0px;
    }
  }
}
</style>
